import React, { PureComponent } from "react";

class CountDown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      count_down: {
        d: "00",
        h: "00",
        m: "00",
        s: "00",
      },
    };
    this.timer = null;
  }
  componentDidMount() {
    const { end_time } = this.props;
    this.startCountDown(end_time);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.end_time !== nextProps.end_time) {
      this.startCountDown(nextProps.end_time);
    }
  }

  render() {
    const { isNewVersionUI } = this.props; 
    const { d, h, m, s } = this.state.count_down;
    if (isNewVersionUI) {
      if (d == '00') {
        if (d == '00' && h == '00' && m == '00' && s == '00') {
          return (
            <p>优惠券已过期</p>
          )
        } else {
          return (
            <p>优惠于{h}:{m}:{s}后失效</p>
          )
        }
      } else {
        return (
          <p>优惠于{d}天{h}:{m}:{s}后失效</p>
        )
      }
    } else {
      if (d == '00' && h == '00' && m == '00' && s == '00') {
        return (
          <p>优惠券已过期</p>
        )
      } else {
        return (
          <p>距离失效还剩{d}天{h}小时{m}分{s}秒</p>
        )
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.timer = null;
  }

  countDown(t) {
    var n = new Date().getTime(),
      c = t - n,
      d,
      h,
      m,
      s;
  
    // 结束执行
    if (c <= 0) {
      return {
        d: "00",
        h: "00",
        m: "00",
        s: "00",
      };
    }
  
    d = parseInt(c / 1000 / 60 / 60 / 24);
    h = parseInt(c / 1000 / 60 / 60 - 24 * d);
    m = parseInt(c / 1000 / 60 - 24 * 60 * d - 60 * h);
    s = parseInt(c / 1000 - 24 * 60 * 60 * d - 60 * 60 * h - 60 * m);
  
    if (s < 10) {
      s = "0" + s;
    }
    if (m < 10) {
      m = "0" + m;
    }
    if (h < 10) {
      h = "0" + h;
    }
    if (d < 10) {
      d = "0" + d;
    }
    return {
      d: d,
      h: h,
      m: m,
      s: s,
    };
  }

  startCountDown(end_time) {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    const timestramp = end_time.replace(/-/g, "/");
    const finish_time = new Date(timestramp).getTime();
    const count_down = this.countDown(finish_time);
    this.setState({
      count_down: count_down,
    });
    this.timer = setInterval(() => {
      // 计算倒计时
      const count_down = this.countDown(finish_time);
      this.setState({
        count_down: count_down,
      });
    }, 1000);
  }
}

export default CountDown;



// WEBPACK FOOTER //
// ./components/pipeline-cashBackAct/countdown.js